import React, {useContext, useEffect, useMemo, useState} from "react";
import styled from "styled-components";
import {Header} from "@/components/Header";
import {useHistory, useLocation} from "react-router-dom/cjs/react-router-dom.min";
import firstImg from '@/assets/frames/first.png';
import secondImg from '@/assets/frames/second.png';
import thirdImg from '@/assets/frames/third.png';
import {Button, Form, Radio, RadioGroup, Slider} from 'rsuite';
import { HexColorPicker } from "react-colorful";
import { SliderPicker, SketchPicker, HuePicker } from 'react-color';
import {KittenLoveFrame, MagicFrame, NeoFrame} from "@/components/frames";
import { useRouteMatch, Route } from "react-router-dom";

import './Editor.css';
import {WidgetInfoContext} from "@/utils/widgetInfoProvider";
import {Rnd} from "react-rnd";

const Mobile = styled.div`
    display: flex;
    height: 100vh;
    background: #0E0F18;
    flex-direction: column;
`;


const Board = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 230px;
    background: #000000;
`;

const Block = styled.div`
    background: #141624;
    padding: 15px;
    margin-top: 1px;
    display: flex;
    justify-content: center;
`;

const EmptyBlock = styled.div`
    padding: 15px;
    margin-top: 1px;
    flex: 1;
`;

export default function Editor() {
    const [scale, setScale] = useState(100)
    const [color, setColor] = useState("#2ec772");
    const [widgetType, setWidgetType] = useState("Neo");
    const widgetContext = useContext(WidgetInfoContext);
    const { url, path } = useRouteMatch();

    const socialInfo = useMemo(() => {
        return widgetContext.socialInfo;
    }, [widgetContext]);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        console.log(socialInfo);
    }, [])

    const onWidgetChange = (val) => {
        setWidgetType(val)
    }

    const onChange = (val) => {
        setScale(val)
    }

    const handleChangeComplete = (newColor) => {
        setColor(newColor.hex);
    };

    const handleClick = () => {
        widgetContext.setWidgetColor(color);
        widgetContext.setWidgetScale(scale);
        history.push(`./display`)
    };

    return (
        <Mobile>
            <Header title={"Choose widget visuals"}/>

            <Board>
                <div>
                    {
                        widgetType === 'Neo' && <NeoFrame color={color} scale={scale / 100} content={socialInfo}/>
                    }
                    {
                        widgetType === 'Old' && <KittenLoveFrame color={color} scale={scale / 100} content={socialInfo}/>
                    }
                    {
                        widgetType === 'Abstract' && <MagicFrame color={color} scale={scale / 100} content={socialInfo}/>
                    }
                </div>
            </Board>

            <Block>
                <RadioGroup name="widgetList" inline onChange={onWidgetChange} defaultValue="Neo">
                    <Radio value="Neo">
                        <img src={firstImg} style={{width: '20vw'}}/>
                    </Radio>

                    <Radio value="Old">
                        <img src={secondImg} style={{width: '20vw'}}/>
                    </Radio>

                    <Radio value="Abstract">
                        <img src={thirdImg} style={{width: '20vw'}}/>
                    </Radio>
                </RadioGroup>
            </Block>

            <Block>
                <HuePicker color={color} onChange={handleChangeComplete}/>
            </Block>

            <EmptyBlock>
                <label>{scale}%</label>
                <Slider
                    defaultValue={100}
                    min={10}
                    step={10}
                    max={100}
                    onChange={onChange}
                    graduated
                    progress
                />
            </EmptyBlock>


            <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '15px'}}>
                <Button appearance="primary" size="lg" onClick={handleClick}>Add widget</Button>
            </div>
        </Mobile>
    );
}